import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { USE_MOCKS } from './lib/env';
import { reloadOnceForChunkError } from './lib/chunk-reload';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/global.css';
import './app/shell.css';
import './components/components.css';

// A tab that predates the latest deploy asks for a chunk that no longer exists
// (Vite fires `vite:preloadError`): reload once to pick up the new index.html.
// When the guard says a reload already happened, let the error reach the
// router's error page (RouteError) instead of looping.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnceForChunkError()) event.preventDefault();
});

async function boot() {
  if (USE_MOCKS) {
    const { startMocks } = await import('./mocks');
    startMocks({ delayMs: 300 });
  }
  document.documentElement.dir = 'rtl';
  document.documentElement.lang = 'ar';
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();
